import React from "react";
import "./App.css";
import SingleCol from "./singleCol";
require("dotenv").config();

function App() {
  return (
    <div className="App">
      <SingleCol />
    </div>
  );
}

export default App;
